import { render, staticRenderFns } from "./customeMenu.vue?vue&type=template&id=fe60bfca"
import script from "./customeMenu.vue?vue&type=script&lang=js"
export * from "./customeMenu.vue?vue&type=script&lang=js"
import style0 from "./customeMenu.vue?vue&type=style&index=0&id=fe60bfca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports